<template>
    <div class="overlay-view">
        <div class="overlay-panel">
            <h1><strong>{{ tile.title }}</strong></h1>
            <h2><strong>{{ tile.header }}</strong></h2>
            <div class="matched-tile"><img class="memory-picture" :src="'/static/img/' + tile.id + '.png'" /></div>
            <!-- eslint-disable-next-line -->
            <h2 v-html="tile.body"></h2>
        </div>

        <button @click="onClickOverlay" class="overlay-button">{{ tile.id === 'ending' ? buttonCopyEnding : buttonCopyGame }}</button>

        <!-- <div class="ending-panel">
            <h1><strong>GOED GEDAAN!</strong></h1>
            <h3><strong>Jij bent nu een #ThinkCircular-kampioen!</strong></h3>
            <img class="ending-picture" src="/static/img/ending.png" />
            <h2>Je hebt alle kaartjes onthouden en je hebt de juiste beelden bij elkaar gezocht. Dat betekent dat je nu weet hoe belangrijk het is om circulair te denken #ThinkCircular en dat je bovendien een heel goed geheugen hebt. Bedankt voor het meespelen!</h2>
            <button @click="goToEnd" class="ending-button"><strong>Opnieuw spelen</strong></button>
        </div> -->
    </div>
</template>

<style lang="scss">

</style>

<script>
    export default {
        props: {
            tile: {
                type: Object,
                default: function()
                {
                    return {};
                }
            }
        },

        computed: {
            buttonCopyGame()
            {
                return this.$store.getters[ 'getCopy' ]( 'game' ).button;
            },

            buttonCopyEnding()
            {
                return this.$store.getters[ 'getCopy' ]( 'ending' ).button;
            }
        },

        methods: {
            onClickOverlay()
            {
                // console.log( 'close' );
                this.$emit( 'close' );
            }

        }
    };
</script>

<!-- Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent ut ullamcorper elit. Donec gravida, nunc eget semper suscipit, risus turpis lobortis orci, ut commodo est ex ut tellus. -->
